import { createSignal } from '@react-rxjs/utils'
import * as React from 'react'
import { useCallback, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { Checkbox } from '../../../form/Checkbox'
import { TestKitLegalTermsModal } from '../TestKitLegalTermsModal'
import * as Styled from './styled'

const [testKitLegalTermsHighlight$, setTestKitLegalTermsHighlight] =
  createSignal<Record<string, never>>()

export const tickTestKitLegalTermsHighlight: () => void = () => setTestKitLegalTermsHighlight({})

interface TestKitLegalTermsProps {
  isDisabled: boolean
}

export const TestKitLegalTerms: React.FC<TestKitLegalTermsProps> = ({ isDisabled }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const openModal = useCallback(() => setIsModalOpen(true), [])
  const closeModal = useCallback(() => setIsModalOpen(false), [])

  const [termsHighlight, setTermsHighlight] = useState<0 | 1 | null>(null)

  useEffect(() => {
    const subscription = testKitLegalTermsHighlight$.subscribe(() => {
      setTermsHighlight((prevState) => (prevState ? 0 : 1))
    })
    return () => subscription.unsubscribe()
  }, [])

  const { errors } = useFormContext()

  useEffect(() => {
    const error = errors['testKitTermsAgree']
    if (error) {
      tickTestKitLegalTermsHighlight()
    }
  }, [errors])

  return (
    <>
      <Styled.Form $highlight={termsHighlight}>
        <Checkbox
          disabled={isDisabled}
          label={
            <Styled.Text>
              By checking this box and adding the <b>Spotlight&trade;</b> program to an eScript or
              purchasing the <b>Spotlight&trade;</b> program, I agree to the{' '}
              <Styled.Button onClick={openModal} disabled={isDisabled}>
                Ordering Clinician Policy
              </Styled.Button>{' '}
              and acknowledge that to receive test results, all samples must be properly submitted
              for processing and received by DSL within one year of the date of original purchase
              from Designs for Health, Inc. No refunds are available for late submissions.
            </Styled.Text>
          }
          name="testKitTermsAgree"
          rules={{ required: true }}
        />
      </Styled.Form>
      <TestKitLegalTermsModal isOpen={isModalOpen} closeModal={closeModal} />
    </>
  )
}
